import React from "react";
import "./InviteFriend.scss";
import {MDBBox} from "mdbreact";
import TopNavSubpage from "../../component/TopNav/TopNavSubpage";
import cogoToast from "cogo-toast";
import {fetchQuery} from "relay-runtime";
import environment from "../../Environment";
import InviteQuery from "../../queries/InviteQuery";
import {Fade, Zoom} from "react-reveal";
import Loading from "../../component/Loading";
import {assetUrl} from "../../serviceApi";
import ReferalBonusQuery from "../../queries/ReferalBonusQuery";

const Sliding = assetUrl+"images/invite_friend1.svg";
const CopyIcon = assetUrl+"images/copy-icon.svg";
const link = assetUrl+"images/icon_link_white.svg";
const whatsapp = assetUrl+'images/icon_whatsapp_invite.svg'
const twitter = assetUrl+'images/icon_twitter_invite.svg'
const fb = assetUrl+'images/icon_fb-invite.svg'
const telegram = assetUrl+'images/icon_telegram_invite.svg'

class InviteFriend extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			copySuccess: '',
			inviteCode: "",
			inviteLink: "",
			setBonus_value:"",
			loadingArray: []
		}
	}

	componentDidMount() {
		this.getInviteCode();
		this.getReferalBonus()
	}
	getReferalBonus = () => {
		let variables = {
			key:"joining_rewards"
		}
		this.updateLoading(true)
		fetchQuery(environment, ReferalBonusQuery, variables)
			.toPromise()
			.then(response => {

				if (response.joiningBonus && response.joiningBonus.edges[0]) {
					this.setState({
					setBonus_value: response.joiningBonus.edges[0].node.value,
				})
					this.updateLoading(false);
				} else {
					this.setState({
						setBonus_value: "",
					})

					this.updateLoading(false);
				}

			}, err => {
				console.log(err);
				this.setState({
					setBonus_value: "",
				})
				this.updateLoading(false)
			});
	}

	getInviteCode = () => {
		let variables = {}
		this.updateLoading(true)
		fetchQuery(environment, InviteQuery, variables)
			.toPromise()
			.then(response => {
				if (response.whoami !== null && response.whoami.id) {
					this.setState({
						inviteCode: response.whoami.referralCode,
						inviteLink: response.whoami.referralLink
						// inviteLink: "https://fe.in.ngrok.io/login/"+response.whoami.referralCode
					})
					this.updateLoading(false)
				} else {
					this.setState({
						inviteCode: "",
						inviteLink: ""
					})
					this.updateLoading(false)
				}
			}, err => {
				console.log(err);
				this.setState({
					inviteCode: "",
					inviteLink: ""
				})
				this.updateLoading(false)
			});
	}

	copyToClipboard = (value) => {
		navigator.clipboard.writeText(value);
		this.setState({copySuccess: 'Copied!'});
	}
	updateLoading = (action) => {

		let tmp_loading_array = this.state.loadingArray;
		if (action) {
			tmp_loading_array.push("loading");
		} else {
			tmp_loading_array.pop();
		}

		this.setState({
			loadingArray: tmp_loading_array
		})
	}

	render() {
		if (this.state.copySuccess !== "") {
			cogoToast.success(this.state.copySuccess, {position: 'top-center'});
		}
		const {inviteCode, inviteLink} = this.state;
		return (
			<Loading loading={this.state.loadingArray.length !== 0}>
				<MDBBox className="invite-component pb-4">

					{/*<SubPageHeader title="Invite a Friend" show_action={false}/>*/}
					<div style={{backgroundColor: "white"}}>
						<TopNavSubpage heading={"Invite a Friend"} notify={false} wallet={false}/>
					</div>
					<div className={"main-content-area"}>
						<div className={"content-area"}>
							<div className={"my-4 d-flex justify-content-center"}>
								<img src={Sliding} alt="Sliding" className="sliding_image m-0"/>
							</div>

							<div className="invite-form-section">
								<Fade cascade delay={500} duration={800}>
									<div className="container px-5 pb-2">
										<div className="text-center">
											<p className="invite-msg mb-2">Invite your Friends
												Reward yourself</p>
											<p className="invite-description mb-2">For every friend that joins, you both
												get {this.state.setBonus_value !== ""?this.state.setBonus_value:0} Neta ₹</p>
										</div>
									</div>
									{/*<div className="container mb-3">*/}
									{/*    <input type="email" className="invite-email-input" value="Email Address"/>*/}
									{/*</div>*/}
									<div className="container my-5">
										<div className="invite-code-section m-auto"
										     onClick={() => this.copyToClipboard(inviteCode)}>
											<div className=" d-flex align-items-center justify-content-center">
												<p className="text-center your-code-text my-1">Your Invite code</p>
												<p className="invite-code my-1 ml-1 mr-2">{inviteCode}</p>
												<img src={CopyIcon} alt="italic_image"
												     className="img-fluid"/>
											</div>
										</div>
									</div>

									{/* shared invite*/}
									<div>
										<p className={"share-link-label pt-4 pb-3 mb-0"}>Share your link & earn
											more!</p>
										<div
											className={"inviteBarWrapper d-flex align-items-center w-100 pb-4 px-4 mb-4"}>

											<input className={"invite-bar "} type={'text'}
											       value={inviteLink ? inviteLink : ""} readOnly={true}/>
											<button className={"invite-button "}
											        onClick={() => this.copyToClipboard(inviteLink)}>
												<img src={link} alt={'alt'}/>
											</button>

										</div>

									</div>
								</Fade>
							</div>

						</div>
						{/*<Zoom cascade delay={1000}>*/}
						{/*	<div className={'d-flex socio-icon-section justify-content-between px-4'}*/}
						{/*	     style={{marginBottom: "35px"}}>*/}
						{/*		<img src={whatsapp} alt={"alt"}/>*/}
						{/*		<img src={twitter} alt={"alt"}/>*/}
						{/*		<img src={fb} alt={"alt"}/>*/}
						{/*		<img src={telegram} alt={"alt"}/>*/}
						{/*	</div>*/}
						{/*</Zoom>*/}
					</div>

				</MDBBox>
			</Loading>
		);
	}
}

export default InviteFriend;